export const arrayEquals = (a: any[] | null, b: any[] | null): boolean => {
  return !!(a?.length === b?.length && a?.every((val, index) => val === b?.[index]));
};
